import React, { useState, useRef, useEffect } from "react";
import Button from "../../components/shared/button";
import ChatHistorySection from "../../components/dashboard/chathistorysection";
import { Icon } from "@iconify/react";
import Input from "../../components/shared/input";
import { Drawer } from "antd";
import { useNavigate } from "react-router-dom";
import { generatePDF, generateRandomId } from "../../utils/helpers";
import { getAllChats, getSingleChat, sendQuery } from "../../APIs/chatApis";
import { set } from "date-fns/fp";
import { ColorRing, Rings, ThreeDots } from "react-loader-spinner";
import MarkedReact from "marked-react";
import SpeechRecognition, { useSpeechRecognition } from "react-speech-recognition";
import { useTranslation } from "react-i18next";

const Chatbot = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [selectedFile, setSelectedFile] = useState(null);
  const [querytext, setQueryText] = useState("");
  const [chatMessages, setChatmessages] = useState([]);
  const [allChats, setAllChats] = useState([]);
  const [threadId, setThreadId] = useState("");
  const [isActive, setIsActive] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isVoice, setIsVoice] = useState(false);
  const [rawData, setRawData] = useState();

  const fileInputRef = useRef(null);
  const messagesEndRef = useRef(null);

  const inputRef = useRef(null);

  const handleInput = () => {
    const input = inputRef.current;
    if (input) {
      input.scrollLeft = input.scrollWidth;
    }
  };

  const { transcript, resetTranscript } = useSpeechRecognition();

  // Start listening with continuous mode enabled
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
  };
  useEffect(() => {
    console.log(selectedFile);
  }, [selectedFile]);
  useEffect(() => {
    scrollToBottom();
    const randomId = generateRandomId();

    const path = window.location.pathname;
    const id = path.split("/").pop();
    if (id == "chatbot") {
      navigate(`/chatbot/${randomId}`);
    }

    getAllChats()
      .then((res) => {
        setAllChats(res);
      })
      .catch((err) => {
        console.log(err);
      });
  }, [chatMessages]);

  useEffect(() => {
    const path = window.location.pathname;
    const id = path.split("/").pop();
    setChatmessages([]);

    getSingleChat(id)
      .then((res) => {
        
        setChatmessages([]);
        res.messages &&
          res.messages.map((item, index) => {
            return setChatmessages((prev) => [
              ...prev,
              {
                role: item.role,
                content: item.content,
                timestamp: item.timestamp,
                files: item?.files,
                sources: item?.sources || null,
              },
            ]);
          });
      })
      .catch((err) => {
        console.log(err);
      });
  }, [threadId]);

  useEffect(() => {
    setChatmessages([]);
  }, [window.location.pathname]);

  useEffect(() => {
    if (isVoice) {
      setQueryText("");
      startListening();
    } else {
      stopListening();
    }
  }, [isVoice]);

  useEffect(() => {
    if (transcript) {
      setQueryText(transcript);
    }
  }, [transcript, resetTranscript]);

  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const handleHammerClick = async () => {
    if (!querytext) return; // Early exit if querytext is empty

    const id = window.location.pathname.split("/").pop();
    stopListening();
    // Add user message to chat
    setChatmessages((prev) => [
      ...prev,
      {
        role: "user",
        content: querytext,
        timestamp: Date.now(),
        files: selectedFile ? [{ filename: selectedFile.name }] : null,
      },
    ]);

    // Reset input and UI state

    setQueryText("");
    setSelectedFile(null);
    setIsActive(true);
    setIsVoice(false);

    try {
      const res = await sendQuery(querytext, id, selectedFile);

      // Add assistant response to chat
      setChatmessages((prev) => [
        ...prev,
        {
          role: "assistant",
          content: res.content,
          timestamp: Date.now(),
          sources: res?.sources || null,
        },
      ]);
    } catch (err) {
      console.error("Error sending query:", err);
    } finally {
      setIsActive(false); // Ensure loading state is turned off
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setSelectedFile(file);
    }
  };

  const handleRemoveFile = () => {
    setSelectedFile(null);
    if (fileInputRef.current) {
      fileInputRef.current.value = "";
    }
  };

  const getThreadId = (id) => {
    navigate(`/chatbot/${id}`);
    setThreadId(id);
  };

  const setNewCase = () => {
    const randomId = generateRandomId();
    navigate(`/chatbot/${randomId}`);
    setChatmessages([]);
  };

  const handleKeyDown = (event) => {
    console.log(event);
    if (event.key === "Enter") {
      event.preventDefault(); 
    console.log("Enter key pressed! Sending message...");
    handleHammerClick(); 
    }
  };

  const handleInputChange = (e) => {
    const inputValue = e.target.value;
    setQueryText(inputValue);
    resetTranscript();
  };

  useEffect(() => {
    if (isVoice) {
      setQueryText("");
      startListening();
      console.log("first ");
    } else {
      console.log("second ");
      stopListening();
    }
  }, [isVoice]);

  const startListening = () => {
    SpeechRecognition.startListening({ continuous: true });
    resetTranscript();
  };
  const stopListening = () => {
    SpeechRecognition.stopListening();
    setTimeout(() => {
      setQueryText("");
      resetTranscript();
    }, 1000);
  };

  if (!SpeechRecognition.browserSupportsSpeechRecognition()) {
    return <p>Your browser does not support speech recognition.</p>;
  }

  return (
    <>
      <div className="chatbot-main flex flex-col gap-[30px] max-sm:gap-[16px] max-sm:mt-[40px]">
        <div className="flex gap-[20px] justify-between items-center">
          <div className="hidden max-sm:flex"></div>
          <h5 className="text-blue font-bold font pl-[15px]">Kameleon AI</h5>
          <div className="hidden max-sm:flex">
            <img
              src={`../../assets/icons/chat-opener.png`}
              alt="Close chat"
              className="hidden max-md:flex cursor-pointer"
              onClick={toggleDrawer}
            />
          </div>
        </div>

        <div className="flex d-flex gap-[10px] h-[83vh]">
          {/* Left switcher */}

          <div className="switcher max-w-[22%] max-sm:hidden drop-shadow-md w-full flex flex-col gap-[34px] bg-[#F8F8F8] px-[15px] py-[21px] border-r-1 border-r-[#fff] border-solid rounded-[28px]">
            <Button
              text="New Case"
              className="button btn-blue-border !rounded-[30px]"
              height={35}
              maxWidth="100%"
              img="lets-icons:chat-light"
              clr="#143A62"
              onClick={() => {
                setNewCase();
              }}
            />

            <div className="history flex flex-col gap-[11px]">
              <p className="large text-blue font-bold">History</p>

              <div className="pr-[21px] overflow-y-auto flex flex-col gap-[26px] max-xxxl:max-h-[54vh] max-h-[69vh]">
                {allChats.today && allChats.today.length > 0 && (
                  <ChatHistorySection
                    title="Today"
                    messages={allChats.today}
                    callbackIds={getThreadId}
                    isActive={isActive}
                  />
                )}

                {allChats.yesterday && allChats.yesterday.length > 0 && (
                  <ChatHistorySection
                    title="Yesterday"
                    messages={allChats.yesterday}
                    callbackIds={getThreadId}
                    isActive={isActive}
                  />
                )}
                {allChats.last7Days && allChats.last7Days.length > 0 && (
                  <ChatHistorySection
                    title="Previous 7 Days"
                    messages={allChats.last7Days}
                    callbackIds={getThreadId}
                    isActive={isActive}
                  />
                )}
                {allChats.last30Days && allChats.last30Days.length > 0 && (
                  <ChatHistorySection
                    title="Previous 30 Days"
                    messages={allChats.last30Days}
                    callbackIds={getThreadId}
                    isActive={isActive}
                  />
                )}
              </div>
            </div>
          </div>

          {/* Main Chat Section */}
          <div className="chat-main relative h-[83vh] max-h-full drop-shadow-md w-full max-w-[78%] max-sm:max-w-full flex flex-col gap-[25px] items-center justify-between bg-[#F8F8F8] px-[76px] max-sm:px-[10px] py-[20px] border-r-1 border-r-[#fff] border-solid rounded-[28px]">
            {chatMessages.length > 0 ? (
              <div className="conversation flex flex-col justify-start  w-full gap-[10px] max-w-[716px] max-sm:max-w-full h-[77vh] !overflow-y-auto pr-[10px]">
                {chatMessages.map((item, index) => {
                  return (
                    <>
                      {item.role == "user" ? (
                        <>
                          {" "}
                          {/* Question Div */}
                          <div className="question-div flex gap-[20px] items-center w-full max-w-full">
                            <div className="w-[44px] h-[40px] rounded-[31px] text-center flex justify-center items-center py-[3px] bg-[var(--Primary-color,#143A62)]">
                              <h6 className="uppercase text-white font-semibold ">t</h6>
                            </div>
                            <div className="flex items-center justify-between gap-[20px] w-full px-[18px] py-[22px] rounded-[14px] border-2 border-solid border-[#E2E8F0]">
                              <p className="text-blue font-bold medium">
                                {item.files && (
                                  <>
                                    <img src="../../assets/icons/doc.png" alt="Document" />
                                    <p
                                      style={{
                                        fontWeight: "400",
                                        fontSize: "12px",
                                        marginBottom: "12px",
                                      }}
                                    >
                                      {item?.files[0]?.filename}
                                    </p>
                                  </>
                                )}

                                {item.content}
                              </p>
                              <Icon
                                icon="mdi:edit"
                                width={22}
                                height={22}
                                color="#718096"
                                className="cursor-pointer"
                              />
                            </div>
                          </div>
                        </>
                      ) : (
                        <>
                          {/* Answer Div */}
                          <div className="answer-div flex gap-[20px] items-center w-full max-w-full ">
                            <img
                              src="../../assets/icons/AIAvatar.svg"
                              alt="AI Avatar"
                              className="w-[40px] h-[40px]"
                            />
                            <div className="flex items-center shadow-[#E1E2EF] w-full shadow-md px-[18px] py-[22px] rounded-[14px] bg-[#FFF]">
                              <p className="text-blue font-medium small leading-[24px]">
                                <MarkedReact>{item.content}</MarkedReact>
                                {/* <br/>
                                <br/>

                                <br/>

                                <br/> */}

                                {/* <ul>
                                  {item.sources.map((source, index) => {
                                    return (
                                      <li key={index}>
                                        <a
                                          href={source}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                        >
                                          {source}
                                        </a>
                                      </li>
                                    );
                                  })}
                                </ul> */}
                                {/* {item.content} */}
                              </p>
                            </div>
                          </div>
                        </>
                      )}
                    </>
                  );
                })}
                <div ref={messagesEndRef} />
             {chatMessages && chatMessages.length > 1 && <button className="p-2 px-4 w-fit" style={{color:'white', backgroundColor:'#143a62', }} onClick={()=>{generatePDF(chatMessages, chatMessages[chatMessages.length - 1])}}>Download Summary</button>} 

              </div>
            ) : (
              <>
                <div></div>
                <h4 className="medium font-medium text-blue text-center">
                  {t("adminDashboard.chatbot.title")}
                </h4>
              </>
            )}

            <div className="send-msg-div max-w-[716px] max-sm:max-w-[100%] w-full flex flex-col gap-[10px] p-[6px] rounded-[43px] border-r-1 border-r-[#fff] border-solid bg-[rgba(255,255,255,0.30)] shadow-[0px_39.919px_73.47px_rgba(191,191,191,0.32)] backdrop-blur-[72.719px]">
              {/* Uploaded File Preview */}
              {selectedFile && (
                <div className="uploaded-file-div px-[20px] py-[8px]">
                  <div className="uploaded-file relative w-fit">
                    <img src="../../assets/icons/doc.png" alt="Document" />
                    <img
                      src="../../assets/icons/doc_cross.png"
                      alt="Remove File"
                      className="absolute top-[-4%] right-[-18%] cursor-pointer"
                      onClick={handleRemoveFile}
                    />
                  </div>
                  <p className="text-sm text-blue mt-[8px]">{selectedFile.name}</p>{" "}
                </div>
              )}

              <div className="w-full flex items-center gap-[16px]">
                <div className="flex gap-[14px] items-center pl-[20px]">
                  {/* File upload icon triggers hidden input */}
                  <Icon
                    icon="fluent-mdl2:attach"
                    width={22}
                    height={22}
                    color="#718096"
                    className="cursor-pointer"
                    onClick={() => fileInputRef.current.click()} // Trigger hidden file input
                  />
                  <input
                    ref={fileInputRef} // Ref to reset the input
                    id="file-input"
                    type="file"
                    className="hidden"
                    disabled={isActive || isVoice}
                    onChange={handleFileChange}


                    // Handle file upload
                  />
                  <div className="bg-[#718096] w-[2px] h-[19px]"></div>
                  {/*    
                  <Icon
                    icon="streamline:voice-mail"
                    width={22}
                    height={22}
                    color="#718096"
                    className="cursor-pointer"
           
                  /> */}
                  <div
                    class={`circle ${isVoice ? "active" : ""}`}
                    onClick={() => {
                      setIsVoice(!isVoice);
                    }}
                  >
                    <Icon
                      icon="streamline:voice-mail"
                      width={18}
                      height={18}
                      className="cursor-pointer voice-icon"
                    />
                  </div>
                </div>
                {isVoice ? (
                  <Input
                    value={querytext}
                    type="text"
                    name="text"
                    placeholder="speak now...."
                    className="dash-input-field overflow-x-auto"
                    wrapperClass="dash-wrapper !p-[0px] !bg-transparent"
                    maxWidth="100%"
                    width="100%"
                    // onChange={handleInputChange}
                    // onKeyDown={(e) => {
                    //   handleKeyDown(e);
                    // }}
                    ref={inputRef}
                    onInput={handleInput}
                    style={
                      {
                        // width: "300px", // Set desired width
                        // overflow: "hidden", // Hide overflowing text
                        // whiteSpace: "nowrap", // Prevent text wrapping
                        // textOverflow: "ellipsis", // Optional: Add ellipsis for overflowing text
                        // fontSize: "16px", // Customize font size
                      }
                    }
                    disabled={true}
                  />
                ) : (
                  <Input
                    value={querytext}
                    type="text"
                    name="text"
                    placeholder={t("adminDashboard.chatbot.placeholder")}
                    className="dash-input-field "
                    wrapperClass="dash-wrapper !p-[0px] !bg-transparent"
                    maxWidth="100%"
                    width="100%"
                    onChange={handleInputChange}
                    // onKeyDown={(e) => {
                    //   handleKeyDown(e);
                    // }}
                    onKeyDown={handleKeyDown}
                    ref={inputRef}
                    onInput={handleInput}
                    style={
                      {
                        // width: "300px", // Set desired width
                        // overflow: "hidden", // Hide overflowing text
                        // whiteSpace: "nowrap", // Prevent text wrapping
                        // textOverflow: "ellipsis", // Optional: Add ellipsis for overflowing text
                      }
                    }
                  />
                )}

                {isActive ? (
                  <Rings
                    visible={true}
                    height="60"
                    width="60"
                    color="#143a62"
                    radius="9"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClass=""
                  />
                ) : (
                  <>
                    {querytext !== "" ? (
                      <img
                        src="../../assets/icons/Hammer.png"
                        alt="Send"
                        className="w-[45px] h-[45px] cursor-pointer"
                        onClick={handleHammerClick}
                      />
                    ) : (
                      <img
                        src="../../assets/icons/Hammer-disabled.png"
                        alt="Send"
                        className="w-[45px] h-[45px] "
                        onClick={handleHammerClick}
                      />
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="mobile-sidebar hidden max-md:flex relative">
        <Drawer
          placement="right"
          closable={false}
          onClose={toggleDrawer}
          open={isDrawerOpen}
          className="rounded-l-[20px] "
          width={280}
        >
          <div className="sidebar-container ">
            <img
              src={
                isDrawerOpen
                  ? "../../assets/icons/sidebarArrow-right.png"
                  : "../../assets/icons/sidebarArrow-left.png"
              }
              alt=""
              className="cursor-pointer absolute left-[-5%] z-[99999]"
              onClick={toggleDrawer}
            />

            <div className="switcher max-w-[100%] drop-shadow-md w-full flex flex-col gap-[34px] bg-[#F8F8F8] px-[15px] py-[21px] border-r-1 border-r-[#fff] border-solid rounded-[28px]">
              <Button
                text="New Case"
                className="button btn-blue-border !rounded-[30px]"
                height={35}
                maxWidth="100%"
                img="lets-icons:chat-light"
                clr="#143A62"
              />

              <div className="history flex flex-col gap-[11px]">
                <p className="large text-blue font-bold">History</p>

                <div className="pr-[21px] overflow-y-auto flex flex-col gap-[26px] ">
                  {allChats.today && allChats.today.length > 0 && (
                    <ChatHistorySection
                      title="Today"
                      messages={allChats.today}
                      callbackIds={getThreadId}
                      isActive={isActive}
                    />
                  )}

                  {allChats.yesterday && allChats.yesterday.length > 0 && (
                    <ChatHistorySection
                      title="Yesterday"
                      messages={allChats.yesterday}
                      callbackIds={getThreadId}
                      isActive={isActive}
                    />
                  )}
                  {allChats.last7Days && allChats.last7Days.length > 0 && (
                    <ChatHistorySection
                      title="Previous 7 Days"
                      messages={allChats.last7Days}
                      callbackIds={getThreadId}
                      isActive={isActive}
                    />
                  )}
                  {allChats.last30Days && allChats.last30Days.length > 0 && (
                    <ChatHistorySection
                      title="Previous 30 Days"
                      messages={allChats.last30Days}
                      callbackIds={getThreadId}
                      isActive={isActive}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </Drawer>
      </div>
    </>
  );
};

export default Chatbot;
